<template>
  <div class="card text-white text-left mb-5">
    <div class="maskot">
      <img src="~@/assets/img/maskot.png" class="maskot-img">
    </div>
    <div class="card-body monaco pt-5">
      <details>
        <summary><strong>Case 6: Menemukan Bilangan Ganjil dalam Rentang Deretan</strong></summary>
        <p>
          <br>
          <strong>Story</strong>: <br>
          Lisa sedang bermain dengan Adiknya, mereka bermain dengan angka bilangan. Lisa memberikan
          <em>challenge</em> kepada Adiknya untuk menemukan bilangan ganjil dari rentang tertentu,
          termasuk dari bilangan negatif. <br><br>
          Bantulah Adiknya Lisa untuk menemukan bilangan ganjil.
          <br><br>
          <strong>Contoh <em>input</em> 1</strong>: <br>
          <pre>
            start: 5
            end: 10
          </pre>
          <strong>Contoh <em>output</em> 1</strong>: <br>
          <pre>
            5 KETEMU
            6
            7 KETEMU
            8
            9 KETEMU
            10
          </pre>

          <strong>Contoh <em>input</em> 2</strong>: <br>
          <pre>
            start: -3
            end: 3
          </pre>
          <strong>Contoh <em>output</em> 2</strong>: <br>
          <pre>
            -3 KETEMU
            -2
            -1 KETEMU
            0
            1 KETEMU
            2
            3 KETEMU
          </pre>
        </p>
      </details>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      nama: '',
      kelas: '',
      jawaban: '',
      submited: false,
      sending: false,
    }
  },

  methods: {
    async submitAnswer() {
      this.sending = true
      let { data, error } = await this.$supabase
      .from('score2023')
      .insert([
        {
          email: this.email,
          nama: this.nama,
          kelas: this.kelas,
          jawaban: this.jawaban,
          case: 1
        }
      ])

      this.sending = false
      if (data) {
        this.submited = true
        this.email = ''
        this.nama = ''
        this.kelas = ''
        this.jawaban = ''
      }
    }
  }
};
</script>

<style scoped>
details {
  margin: 20px 0 20px 0;
}
pre {
  padding: 20px;
  padding-left: 0;
  padding-right: 0;
  color: #fff;
  background-color: #0b0b0b;
  border-top: 3px solid #fff;
  border-bottom: 3px solid #fff;
}
</style>
